import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { LoginNovoComponent } from './login-novo.component';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  imports: [
    SharedModule,
    RecaptchaModule
  ],
  declarations: [
    LoginNovoComponent
  ],
  providers: [ 
    
  ]
})
export class LoginModule { }
